// Centralized configuration for API and asset base URLs
// Values are read from environment variables at build time.
// For Create React App, variables must be prefixed with REACT_APP_.

const DEFAULT_API_BASE = 'https://inv-api.internal.trakshym.com/api';
const DEFAULT_ASSET_BASE = 'https://inv-api.internal.trakshym.com';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '') || DEFAULT_API_BASE;

export const ASSET_BASE_URL =
  process.env.REACT_APP_ASSET_BASE_URL?.replace(/\/$/, '') || DEFAULT_ASSET_BASE;

export default { API_BASE_URL, ASSET_BASE_URL };
